'use strict';
const angular = require('angular');

export default angular.module('terrappApp.compareTo', [])
  .directive('compareTo', function(PickupOptionsService, $uibModal) {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                return modelValue == scope.otherModelValue;
            };
        
            scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });
        }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/compareTo/compareTo.directive.ts